import React from 'react'

export const HeaderCell = ({ title }) => (
  <div className='p-2 row-start-1 text-center border border-gray-300'>
    <strong>{title}</strong>
  </div>
)
